import React from 'react';

import type { AutocompleteState } from '@algolia/autocomplete-core';
import classNames from 'classnames';

import { IndexTypes, DocSearchHit } from '../../../../types';
import { Hit } from '../Hit';
import { Snippet } from '../Snippet';

import * as classes from './style.module.scss';

interface Props {
  index: number;
  item: DocSearchHit;
  collection: AutocompleteState<DocSearchHit>['collections'][0];
  renderIcon: (props: { item: DocSearchHit; index: number }) => React.ReactNode;
  renderAction: (props: {
    item: DocSearchHit;
    runDeleteTransition: (cb: () => void) => void;
    runFavoriteTransition: (cb: () => void) => void;
  }) => React.ReactNode;
  onItemClick: (item: DocSearchHit) => void;
  // note: comes from autocomplete
  getItemProps: any;
}

export const Result: React.FC<Props> = ({
  index,
  item,
  onItemClick,
  collection,
  renderAction,
  renderIcon,
  // note: comes from autocomplete
  getItemProps,
}) => {
  const [isDeleting, setIsDeleting] = React.useState(false);
  const [isFavoriting, setIsFavoriting] = React.useState(false);
  const action = React.useRef<(() => void) | null>(null);

  function runDeleteTransition(cb: () => void) {
    setIsDeleting(true);
    action.current = cb;
  }

  function runFavoriteTransition(cb: () => void) {
    setIsFavoriting(true);
    action.current = cb;
  }

  return (
    <li
      className={classNames('DocSearch-Hit', {
        'DocSearch-Hit--Child': item.type !== IndexTypes.PAGE,
        'DocSearch-Hit--deleting': isDeleting,
        'DocSearch-Hit--favoriting': isFavoriting,
      })}
      onTransitionEnd={() => {
        if (action.current) {
          action.current();
        }
      }}
      {...getItemProps({
        item,
        source: collection.source,
        onClick() {
          onItemClick(item);
        },
      })}
    >
      <Hit hit={item}>
        <div className="DocSearch-Hit-Container">
          {renderIcon({ item, index })}
          {item && (
            <div className="DocSearch-Hit-content-wrapper">
              <span
                className={classNames(classes.title, 'DocSearch-Hit-title')}
              >
                <Snippet item={item} />
              </span>
            </div>
          )}
          {renderAction({ item, runDeleteTransition, runFavoriteTransition })}
        </div>
      </Hit>
    </li>
  );
};
